export const BREEZE_TOOLTIP_DELAY = 500; // 500ms

export const CHATSPOT_TOOLTIP_DELAY = 1200; // 1200ms